import { Pill } from "@src/appV2/redesign/system/ui-components";

export const CLOCK_OUT_ADJUSTMENT_NOTICE_LABEL =
  "Your shift time was adjusted to the scheduled shift end time. You may request a pay adjustment later in your Shift History.";

/**
 * Yellow warning pill rendered under the clock-out row on the timesheet when
 * the worker's clock-out was capped at the scheduled shift end because they
 * did not complete the shift-extension flow. Used by both the editable
 * (`TimesheetTimeEntries`) and read-only (`ReadOnlyTimesheetTimeEntries`)
 * timesheet variants so the copy/colors/icon stay in lockstep.
 */
export function ClockOutAdjustmentNoticePill() {
  return (
    <Pill
      multiline
      size="small"
      variant="filled"
      iconType="triangle-exclamation"
      label={CLOCK_OUT_ADJUSTMENT_NOTICE_LABEL}
      backgroundColor={(theme) => theme.palette.intent?.warning.background}
      color={(theme) => theme.palette.intent?.warning.text}
      iconColor={(theme) => theme.palette.intent?.warning.icon}
    />
  );
}
